import { computed, Directive, input } from '@angular/core';
import { ButtonLayout, ButtonVariant } from './models/button.model';
import { Size } from '../../models/size.model';

@Directive({ selector: '[ds-button]', host: {
  '[class]': '$classes()',
  type: 'button',
} })
export class ButtonDirective {
  /**
   * ================================================
   * Inputs
   * ================================================
   */
  /**
   * The type of the button. Useful if you want to use the button with an icon.
   * @default text-button
   */
  $layout = input<ButtonLayout>('text-button', { alias: 'layout' });
  /**
   * The size of the button.
   * @default l
   */
  $size = input<Omit<Size, 'xl'>>('l', { alias: 'size' });
  /**
   * The variant of the button.
   * @default primary
   */
  $variant = input<ButtonVariant>('primary', { alias: 'variantName' });
  /**
   * ================================================
   * Computed
   * ================================================
   */
  $classes = computed(() => [
    `ds-button`,
    `ds-button-${this.$variant()}`,
    `ds-button-${this.$size()}`,
    `${this.$layout()}`,
  ].join(' ')
  );
}
